import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { SampleRequestVariantPackFieldsFragment } from '@/types';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  sampleRequest: SampleRequestVariantPackFieldsFragment;
}

export const SampleRequestLimitMessage: React.FC<Props> = ({
  sampleRequest,
}) => {
  const [styles] = useStyles();

  const {
    advertiser_name: advertiser,
    lookback_period_days: lookback,
    request_count: count,
    request_limit: limit,
  } = sampleRequest;

  const hasLimit = typeof limit === 'number' && typeof count === 'number';
  // Prevent showing negative remaining samples if limit is decreased
  const remaining = hasLimit ? Math.max(limit - count, 0) : null;

  return hasLimit && typeof remaining === 'number' ? (
    <View style={styles.base}>
      <Text
        style={[
          TYPOGRAPHY.pSemiBold,
          remaining > 0 ? styles.hasRemaining : styles.lastRequest,
        ]}
      >
        {i18n.t('sample_request.remaining_limit', {
          advertiser,
          limit,
          remaining,
        })}
      </Text>
      <Text style={TYPOGRAPHY.listSmall}>
        {i18n.t('sample_request.limit_message', {
          advertiser,
          limit,
          lookback,
        })}
      </Text>
    </View>
  ) : null;
};

const useStyles = createStyles((theme) => ({
  base: {
    gap: 4,
    marginBottom: 16,
  },
  hasRemaining: {
    color: theme.colors.darkGreen,
  },
  lastRequest: {
    color: theme.colors.negative,
  },
}));
